<template>
  <el-dialog
    title="退回"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div
        class="flex"
        style="
          padding: 27px 20px;
          background: linear-gradient(180deg, #dcf0ff 0%, rgba(255, 255, 255, 0) 100%);
          border-radius: 4px 4px 0px 0px;
        "
      >
        <div>
          <img src="@/assets/image/finish.svg" alt="" />
        </div>
        <div style="margin-left: 20px">
          <div
            style="
              font-family: MiSans, MiSans;
              font-weight: 500;
              font-size: 18px;
              color: #494c4f;
              line-height: 26px;
            "
          >
            您确定退回此问题吗？
          </div>
          <div
            style="
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 14px;
              color: #92979c;
              line-height: 22px;
            "
          >
            您可以在下方输入退回原因进行说明
          </div>
        </div>
      </div>
      <el-form :model="formInline" ref="form" style="padding: 0 24px">
        <el-form-item label="退回" prop="backReason">
          <el-input
            v-model="formInline.backReason"
            placeholder="请输入"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { reportTaskback } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      formInline: {
        typeName: "",
        enableStatus: 0,
        id: "",
      },
      rules: {
        typeName: [{ required: true, message: "请输入点位类型", trigger: "blur" }],
        enableStatus: [{ required: true, message: "请选择是否启用", trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.curItem && this.curItem.taskHandleId)
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      let params = {
        backReason: this.formInline.backReason,
        id: this.formInline.taskHandleId,
      };
      let res = await reportTaskback(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 0px 0px;
}

/deep/ .el-dialog__header {
  display: none;
}

/deep/.el-input {
  width: auto !important;
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/problemAnalysis/components/addDialog.vue